import { fmt } from 'IntlWrapper/IntlWrapper';
import { URL_FLAGS } from './country-data';
import { getCountryFullName } from 'common/countries/constants/countries';
import { getFormattedNumber } from 'utils/number';

export const INTERNATIONAL_DROPOFF_COUNTRIES = [
  { value: 'A', label: fmt({ id: 'pricing.zones.a' }) },
  { value: 'B', label: fmt({ id: 'pricing.zones.b' }) },
  { value: 'C', label: fmt({ id: 'pricing.zones.c' }) }
];

export const INTERNATIONAL_PICKUP_COUNTRIES = {
  EG: {
    value: 'EG',
    label: (
      <div className="br-pricing__inter-location-option">
        <img
          className="br-international-pricing__country-flag"
          src={URL_FLAGS + 'eg' + '.svg'}
          alt="flag"
        />
        <p className="body br-pricing__location-option-country-name">
          {getCountryFullName('EG')}
        </p>
      </div>
    )
  }
};

export const INTERNATIONAL_SHIP_LOCATIONS = {
  FROM: [
    {
      value: 'UAE',
      label: (
        <div className="br-pricing__inter-location-option">
          <img
            className="br-international-pricing__country-flag"
            src={URL_FLAGS + 'ae' + '.svg'}
            alt="flag"
          />
          <p className="body">United Arab Emarates</p>
        </div>
      ),
      code: 'UAE'
    }
  ],
  TO: [
    {
      value: 'SA',
      label: (
        <div className="br-pricing__inter-location-option">
          <img
            className="br-international-pricing__country-flag"
            src={URL_FLAGS + 'sa' + '.svg'}
            alt="flag"
          />
          <p className="body">Saudi Arabia</p>
        </div>
      ),
      code: 'SA'
    }
  ]
};

export const INTERNATIONAL_CURRENCY_ID = 'common.usd_amount';

export const USD_LOCALIZED = (cod) =>
  fmt(
    { id: 'common.usd_amount' },
    {
      cod
    }
  );
